import {
  colors,
  Select,
  StapleTableCell,
  StapleTableHeading,
  ActionModal,
  typography,
  FileUpload,
  Button,
} from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils';
import styled from 'styled-components';

export const ActionModalStyled = styled(ActionModal)`
  max-width: 80rem;
  padding: 2.4rem 5.6rem;
  box-sizing: border-box;

  ${breakpointsMQ4.lg.down} {
    max-width: 90%;
  }
`;

export const FileUploadStyled = styled(FileUpload)`
  background-color: ${colors.neutral.white};
`;

export const ActionPanelStyled = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 3rem;
`;

export const ButtonStyled = styled(Button)`
  margin-top: 2.8rem;
`;

export const SelectStyled = styled(Select)`
  flex: 1;
`;

export const FileNameStyled = styled.span`
  word-break: break-all;
`;

export const NoDataMessageStyled = styled.div`
  ${typography.regular[16]}
  color: ${colors.neutral[900]};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  margin-top: 3rem;
`;

export const UploadedFilesSectionTitleStyled = styled.h3`
  ${typography.bold[20]};
  color: ${colors.neutral[700]};
  margin: 0 0 2rem;
  text-align: left;
`;

export const StapleTableHeadingStyled = styled(StapleTableHeading)`
  text-align: right;

  &:last-child {
    padding-right: 4rem;
  }
`;

export const StapleTableCellStyled = styled(StapleTableCell)`
  text-align: right;
`;

export const ActionButtonsStyled = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 2rem;
`;
